import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingsServicedeskAutomationRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskAutomationRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import Automation, { LazyProjectSettingsJiraAutomation } from './ui/jira-automation/index.tsx';
import { SERVICE_DESK_PRODUCT } from './ui/product-routes/common/index.tsx';

export const projectSettingsServicedeskAutomationRouteEntry = createEntry(
	projectSettingsServicedeskAutomationRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: `project-settings-automation-${SERVICE_DESK_PRODUCT}`,
		component: Automation,
		layout: serviceProjectLayout,

		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsJiraAutomation],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskAutomationRouteEntry.tsx',
				whichExportToUse: 'projectSettingsServicedeskAutomationRouteEntry',
			},

			enabled: true,
		},
	}),
);
